import React, { useEffect, useState } from "react"
import Modal, { ModalHeader } from "../../../components/Modal"
import Button from "../../../components/Button"
import DataComponent from "../../../components/DataComponent";

const ItemHistory = ({ open, setOpen, data, setData }) => {
  const [fields] = useState([
    {
      title: "품목분류",
      key: "category",
    },
    {
      title: "품목명",
      key: "name",
    },
    {
      title: "품목코드",
      key: "code",
    },
    {
      title: "규격",
      key: "size",
    },
    {
      title: "구분",
      key: "division",
    },
    {
      title: "단위",
      key: "unit",
    },
    {
      title: "매입단가",
      key: "buyPrice",
      transform: 'comma'
    },
    {
      title: "판매단가",
      key: "sellPrice",
      transform: 'comma'
    },
    {
      title: '재고수량',
      key: 'qty',
      transform: 'comma'
    },
    {
      title: "메모",
      key: "memo",
    },
  ]);

  const cancel = () => {
    setOpen(false)
    setData(null)
  }

  useEffect(() => {
    if (data.type === 'qtyChange') {
      const presentDataQty = data.prevData && data.prevData.qty + data.qty
      data.data.qty = presentDataQty
    }
  }, [data])

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="item-history-modal">
        <ModalHeader>품목 히스토리</ModalHeader>
        <div className="prev-data">
          <p className="sub-title">변경 전 품목 정보</p>
          <div className="item-container">
            {fields.map((field, idx) => (
              <div className="item-wrapper" key={idx}>
                <label className="item-label">{field.title}</label>
                <DataComponent field={field} data={data.prevData} />
              </div>
            ))}
          </div>
        </div>
        <div className="after-data">
          <p className="sub-title">변경 후 품목 정보</p>
          <div className="item-container">
            {fields.map((field, idx) => (
              <div className="item-wrapper" key={idx}>
                <label className="item-label">{field.title}</label>
                <DataComponent field={field} data={data.data} />
              </div>
            ))}
          </div>
        </div>
        <div className="float-right">
          <Button label="취소" color="text" onClick={cancel} />
        </div>
      </div>
    </Modal>
  )
}

export default ItemHistory